// extracted by mini-css-extract-plugin
export default {"drop-over-downward":"DraggableBodyRow_drop-over-downward__BkKwN","drop-over-upward":"DraggableBodyRow_drop-over-upward__tE1mW","drag-icon":"DraggableBodyRow_drag-icon__UlXGs"};